import { Component, OnInit, Input} from '@angular/core';
import {Reservation} from '../../api/model/reservation/reservation.model';
import {Hotel} from '../../api/model/hotel/hotel.model';


@Component({
  selector: 'reservation-policies',
  templateUrl: './reservation-policies.component.html',
  styleUrls: ['./reservation-policies.component.scss']
})
export class ReservationPoliciesComponent implements OnInit {
  @Input() hotel: Hotel;
  @Input() messages;
  private _reservation: Reservation;
  showCancellation: boolean;
  cancellationPolicy: string;
  secondaryPolicies: Array<string>;
  disclaimers: Array<string>;

  get reservation(): Reservation {
    return this._reservation;
  }
  @Input()
  set reservation(value: Reservation) {
    if (!value) { return; }
    this._reservation = value;
    this.initPolicies();
  }
  ngOnInit() {
    this.showCancellation = false;
  }

  clickCancellation() {
    this.showCancellation = !this.showCancellation;
  }

  private initPolicies() {
    this.cancellationPolicy = this.reservation.rate.cancellationPolicy.primaryPolicy;
    this.secondaryPolicies = this.reservation.rate.cancellationPolicy.secondaryPolicies;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/reservation-policies/reservation-policies.component.ts